import { useCurrentUserContext } from '@/modules/auth/hooks/useCurrentUserContext';
import { useGetPayments } from '@/modules/payments/hooks/usePayments';
import {
  ApplicationStatus,
  IApplicationWithOrderAndCourse,
} from '@/types/application';
import { ICompany } from '@/types/company';
import { PaymentStatus } from '@/types/payment';

function useApplicationPayments(row: {
  original: IApplicationWithOrderAndCourse;
}) {
  const { currentUser, isLoading: isLoadingCurrentUser } =
    useCurrentUserContext() ?? {};
  const shouldFetchPayments = !!(
    row.original.statuses?.includes(ApplicationStatus.Approved) &&
    row.original.order?.paymentDetails?.length
  );
  const paymentIds =
    row.original.order?.paymentDetails?.map(payment => payment.document) ?? [];
  const { data: { data: payments = [] } = {}, isLoading: isLoadingPayments } =
    useGetPayments(
      {
        id: paymentIds.length ? paymentIds : undefined,
      },
      undefined,
      undefined,
      undefined,
      {
        enabled: shouldFetchPayments,
      },
    );
  const showPayNowButton =
    shouldFetchPayments &&
    !isLoadingPayments &&
    !isLoadingCurrentUser &&
    payments.some(
      payment =>
        [
          PaymentStatus.Pending,
          PaymentStatus.WaitingFunds,
          PaymentStatus.InCheckout,
        ].includes(payment.status) &&
        payment.payer === (currentUser?.company as ICompany)?._id,
    );
  const showAvailableChip = payments.some(
    payment =>
      payment.status === PaymentStatus.Pending &&
      payment.payer === (currentUser?.company as ICompany)?._id,
  );
  const showProcessingChip = payments.some(
    payment => payment.status === PaymentStatus.WaitingFunds,
  );
  return {
    shouldFetchPayments,
    isLoadingPayments,
    isLoadingCurrentUser,
    payments,
    showPayNowButton,
    showAvailableChip,
    showProcessingChip,
  };
}

export default useApplicationPayments;
